module.exports = __webpack_public_path__ + "static/media/womengroup.188b3125.svg";